<template>
  <v-list>
    <v-list-group
      v-for="item in items"
      :key="item.title"
      v-model="item.active"
      no-action
      :value="false"
      style="background:rgb(25, 118, 210, 0.1)"
      class="priceMenu-group"
    >
      <template v-slot:activator>
        <v-list-item-content class="pa-2 priceMenu_title" fixed>
          <v-list-item-title v-text="item.title" class="body-2"></v-list-item-title>
        </v-list-item-content>
      </template>

      <v-divider></v-divider>
      <div
        class="pa-3 overflow-y-auto"
        style="background-color: rgba(0, 0, 0, 0.05); max-height: 300px;"
        >

        <v-list-item
            v-for="subItem in item.items"
            :key="subItem.type"
            class="priceMenuItem"
          >
          <div :class="'logoWidth' + 10" class="bookieLogo mb-2">
            <div class="opacityHover tooltip"><RaceBookmakers :bookieCode="subItem.source"/></div>
          </div>

          <v-list-item-content>
            <v-list-item-title v-text="getTitle(subItem.source, subItem.type)"></v-list-item-title>
          </v-list-item-content>

          <v-btn class="priceMenuItem-button" x-small @click="handleClick(subItem.source, subItem.type, 'WIN')">WIN</v-btn>
          <v-btn :disabled="hasPlacePrice(subItem)" x-small @click="handleClick(subItem.source, subItem.type, 'PLACE')">PLACE</v-btn>
        </v-list-item>
      </div>
      <v-divider></v-divider>
    </v-list-group>
  </v-list>
</template>

<script>
import { BOOKMAKER_NAMES_LOOKUP, BETFAIR_BET_TYPE_LOOKUP, BETFAIR_PLACE } from '../../common/constants'
import RaceBookmakers from '../RaceBookmakers'

export default {
  data: () => ({
    fav: true,
    menu: false,
    items: [
      {
        type: 'back',
        title: 'Back',
        items: [
          { source: 'BF', type: 'back-1', level: 0 },
          { source: 'BF', type: 'back-2', level: 1 },
          { source: 'BF', type: 'back-3', level: 2 },
          { source: 'BF', type: 'back-amount-1', level: 0 },
          { source: 'BF', type: 'back-amount-2', level: 1 },
          { source: 'BF', type: 'back-amount-3', level: 2 }
        ]
      },
      {
        type: 'lay',
        title: 'Lay',
        items: [
          { source: 'BF', type: 'lay-1', level: 0 },
          { source: 'BF', type: 'lay-2', level: 1 },
          { source: 'BF', type: 'lay-3', level: 2 },
          { source: 'BF', type: 'lay-amount-1', level: 0 },
          { source: 'BF', type: 'lay-amount-2', level: 1 },
          { source: 'BF', type: 'lay-amount-3', level: 2 }
        ]
      },
      {
        type: 'other',
        title: 'Other',
        items: [
          { source: 'BF', type: 'last-matched-price' },
          { source: 'BF', type: 'projected-sp' },
          { source: 'BF', type: 'total-matched' },
          { source: 'BF', type: 'weighted-avg' }
        ]
      }
    ]
  }),
  props: {
    addColumn: Function,
    flucs: Boolean
  },
  components: {
    RaceBookmakers
  },
  methods: {
    getTitle: function (source, type) {
      return `${BOOKMAKER_NAMES_LOOKUP[source]} ${BETFAIR_BET_TYPE_LOOKUP[type]}`
    },
    handleClick: function (source, type, priceType) {
      const column = { source, type, display: 0, priceType }
      this.addColumn(column)
    },
    hasPlacePrice: function (source) {
      return !BETFAIR_PLACE[source.type]
    }
  }
}
</script>

<style>
  .bookieLogo {
    display: flex;
    margin: 0 15px 0 0;
  }
  .priceMenuItem button {
    margin-right: 5px;
  }
  .v-list-item--active {
    background-color: rgb(25, 118, 210, 0.2);
  }
</style>
